import { connect } from 'react-redux';
import { Link } from "react-router-dom";

var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices")

var Spinner = require("components/utility/Spinner");
var LoadingButton = require("components/utility/LoadingButton");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("trials/gold_trial.scss");

class GoldTrialModal extends React.Component {
  constructor(props) {
    super();
    autobind(this);
    LuckyOrangeClient.tagComponent("GoldTrialModal");
    this.state = { showBasicInfo: true, loading: false }
  }
  // removes gold trial alert
  startFreeTrial() {
    this.setState({ loading: true })
    LuckyOrangeClient.tagComponent("startGoldTrial");
    Mycroft.newEvent({ category: "Gold Trial", action: "gold-trial-initiated" });
    // remove alert for gold trial
    CurrentUser.api().deleteUserAlert(this.props.alertID);
  }
  // shows additonal information modal
  showInformation() {
    this.setState({ showBasicInfo: false })
  }
  // renders start trial button or spinner
  renderStartTrialButton() {
    // construct url to start trial
    var user = CurrentUser.get()
    var trialPath = "/users/" + user.id + "/trigger?what=trial&features=wrGold&days=60&numReferred=0";
    var trialURL = WhooosReadingServices.ApiServer.url(trialPath);

    if (this.state.loading) {
      return <Spinner scale={1} />
    } else {
      return (
        <div className="row buttonRow">
          <div className="startTrialBtnContainer">
            <div className='btnAndText'>
              <a className="btn buttonSuccess" href={trialURL} onClick={this.startFreeTrial}>Start Your Free Trial</a>
              <div className='noCreditCardText'>(No credit card required!)</div>
            </div>
          </div>
          <div className='startTrialImageContainer'>
            <img className="teacherOwl" src={require("onboarding/teacher-owl.png")} />
            <img className="studentOwl" src={require("onboarding/student-owl.png")} />
          </div>
        </div>
      )
    }
  }
  // renders first modal
  renderBasicInfo() {
    if (this.state.showBasicInfo) {
      var user = CurrentUser.get()
      var trialPath = "/users/" + user.id + "/trigger?what=trial&features=wrGold&days=60&numReferred=0";
      var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
      var checkMarkIcon = <Glyphicon icon={"glyphicon glyphicon-ok"} />
      return (
        <div className="goldTrialContainer">
          <div className="row contentRow">
            <div className="col-sm-12">
              <div className='featureListIntro'>Gain access to these features to help you and your students:</div>
              <ul className='featureListContainer'>
                <li>{checkMarkIcon} Identify which students demonstrate comprehension</li>
                <li>{checkMarkIcon} Differentiate and customize scaffolds for each student</li>
                <li>{checkMarkIcon} Track students’ daily reading using a digital reading log</li>
                <li>{checkMarkIcon} Encourage students to read within their ZPD reading level</li>
                <li>{checkMarkIcon} Activate standards-aligned questions and reporting</li>
                <li>{checkMarkIcon} Customize activities assigned alongside specific titles</li>
                <li>{checkMarkIcon} Track reading and writing skills where support is needed</li>
                <li>{checkMarkIcon} Assign intervention exercises based on student need</li>
                <li>{checkMarkIcon} Observe reading and writing proficiency over time</li>
              </ul>
            </div>
          </div>
            {this.renderStartTrialButton()}
        </div>
      );
    }
  }
  // controlls display of information based on user input
  renderDisplay() {
    if (this.state.showBasicInfo) {
      return this.renderBasicInfo()
    } else {
      return this.renderMoreInfoModal()
    }
  }

  render() {
    return (
      <div>
        {this.renderDisplay()}
      </div>
    );
  }
};

module.exports = GoldTrialModal;


// WEBPACK FOOTER //
// ./modules/components/trials/GoldTrialModal.js